import { render, staticRenderFns } from "./royaltyReport.vue?vue&type=template&id=bfe01364&scoped=true"
import script from "./royaltyReport.vue?vue&type=script&lang=js"
export * from "./royaltyReport.vue?vue&type=script&lang=js"
import style0 from "./royaltyReport.vue?vue&type=style&index=0&id=bfe01364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe01364",
  null
  
)

export default component.exports